export const customAnalyticsUICopy = {
  charts: {
    'media-interactions-by-type': {
      subTitle: "What kinds of media work you're logging most",
      headerBadges: ['Type'],
      scope: 'Included: media interactions in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups media interactions by Type of Work.',
        'If an interaction has multiple Types of Work, it is counted in each applicable Type.',
        'Uses your selected filters (Status, Type, Outlet, Department, Campaigns, Units, Team Members).',
      ],
    },

    'media-interactions-by-team-member': {
      subTitle: "Who's handling the most interactions",
      scope: 'Included: media interactions in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: ['Groups media interactions by the assigned Lead.', 'Uses your selected filters.'],
    },

    'services-by-team-member': {
      subTitle: "Who's owning the most service work",
      scope: 'Included: services in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups services by the assigned Owner.',
        'Uses your selected filters (Status, Type, Department, Campaigns, Units, Team Members).',
      ],
    },

    'proactive-vs-reactive-media-interactions': {
      subTitle: 'A quick look at proactive work versus response work',
      scope: 'Included: media interactions in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Proactive includes interactions with Types of Work marked Proactive (on tactics).',
        'Reactive includes interactions with Types of Work marked Reactive (on tactics), plus issue-type work.',
        'Proactive and reactive totals are counted separately.',
        'If an interaction includes both proactive and reactive tactic tags, it can be counted in both totals.',
        'Percentages are calculated from the proactive and reactive totals for each month.',
      ],
    },

    'campaign-distribution': {
      subTitle: 'Which campaigns are generating the most activity',
      scope: 'Included: media interactions in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups media interactions by Campaign.',
        'Interactions without a campaign appear under "No Campaign."',
        'Uses your selected filters.',
      ],
    },

    'top-media-interaction-topics-overall': {
      subTitle: 'The most common topics across all media interactions',
      scope: 'Included: all media interactions in your selected filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups media interactions by the Topic field.',
        'Includes all media interactions in your selected filters.',
        'Topics are counted exactly as entered (spelling, capitalization, and spacing matter).',
      ],
    },

    'top-media-interaction-topics-overall-word-cloud': {
      subTitle: 'The most common topics across all media interactions',
      scope: 'Included: all media interactions in your selected filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Shows topic keywords by frequency.',
        'Includes all media interactions in your selected filters.',
        'Topics are counted exactly as entered (spelling, capitalization, and spacing matter).',
      ],
    },

    'top-media-issue-topics': {
      subTitle: 'The issue themes showing up most often',
      headerBadges: ['Issue'],
      scope: 'Included: interactions tagged as Issue or Issue Response (within your filters).',
      infoTitle: 'How this chart is counted',
      infoBody: [
        "Shows the most common issue topics based on each interaction's topic field.",
        'Includes interactions tagged as Issue or Issue Response.',
        'Topics are counted exactly as entered (spelling, capitalization, and spacing matter).',
        'Uses your selected filters.',
      ],
    },

    'top-media-interactions-by-unit': {
      subTitle: 'Which parts of the organization are most involved',
      scope: 'Included: media interactions in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups media interactions by Unit.',
        'Interactions without a unit appear under "No units."',
        "If you filter to specific Units, unassigned items won't be included in that filtered view.",
        'Uses your selected filters.',
      ],
    },

    'top-proactive-media-topics': {
      subTitle: "What you're most often pushing proactively",
      headerBadges: ['Support'],
      scope: 'Included: interactions tagged Proactive (and not tagged Reactive), within your filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        "Shows the most common proactive topics based on each interaction's topic field.",
        'Includes interactions with at least one Type of Work marked Proactive and no Types of Work marked Reactive.',
        'Topics are counted exactly as entered (spelling, capitalization, and spacing matter).',
        'Uses your selected filters.',
      ],
    },

    'complexity-of-services': {
      subTitle: 'How heavy the work has been',
      headerBadges: ['Complexity'],
      scope: 'Included: services in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: ['Groups services by complexity rating.', 'Uses your selected filters.'],
    },

    'media-interactions-compared-to-past-years': {
      subTitle: 'How this period compares to the same window in previous years',
      scope: 'Included: media interactions in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Compares interaction volume to previous years using the same time window.',
        'Uses your selected filters so the comparison stays consistent.',
      ],
    },

    'top-service-areas-unit': {
      subTitle: 'Which Units are generating the most service work',
      scope: 'Included: services in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups services by Unit.',
        'Services without a unit appear as "No unit."',
        "If you filter to specific Units, unassigned items won't be included in that filtered view.",
        'Uses your selected filters.',
      ],
    },

    'top-media-areas-unit': {
      subTitle: 'Which Units are driving the most media interaction volume',
      scope: 'Included: media interactions in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups media interactions by Unit.',
        'Interactions without a unit appear as "No unit."',
        "If you filter to specific Units, unassigned items won't be included in that filtered view.",
        'Uses your selected filters.',
      ],
    },

    'services-by-type': {
      subTitle: "What kinds of services you're logging most often",
      headerBadges: ['Type'],
      scope: 'Included: services in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups services by Type of Work.',
        'Media Request services are not included in this view.',
        'If a service has multiple Types of Work, it is counted in each applicable Type.',
        'Uses your selected filters.',
      ],
    },

    'top-complex-services': {
      subTitle: 'Your most effort-intensive services',
      headerBadges: ['Complexity'],
      scope: 'Included: services in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Lists the services with the highest complexity.',
        'Uses your selected filters (Status, Type, Department, Campaigns, Units, Team Members).',
      ],
    },

    'top-20-media-outlets': {
      subTitle: 'Which outlets are interacting with you most',
      scope: 'Included: interactions that can be linked to an outlet through the journalist record.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Ranks outlets by number of media interactions.',
        "Outlets are determined by the interaction's journalist, then linked to that journalist's organization.",
        'Interactions without a linked journalist and organization are excluded.',
        'Uses your selected filters.',
      ],
    },

    'interactions-by-tone': {
      subTitle: 'The overall tone of media interactions',
      scope: 'Included: media interactions in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups media interactions by tone.',
        'Interactions without a tone appear under "N/A."',
        'Uses your selected filters.',
      ],
    },

    'services-by-status': {
      subTitle: 'Where services sit in your workflow',
      headerBadges: ['Status'],
      scope: 'Included: services in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: ['Groups services by status.', 'Uses your selected filters.'],
    },

    'interactions-by-status': {
      subTitle: 'Where interactions sit in your workflow',
      headerBadges: ['Status'],
      scope: 'Included: media interactions in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: ['Groups media interactions by status.', 'Uses your selected filters.'],
    },

    'top-proactive-media-topics-word-cloud': {
      subTitle: "What you're most often pushing proactively",
      headerBadges: ['Support'],
      scope: 'Included: interactions tagged Proactive (and not tagged Reactive), within your filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        "Shows proactive topic keywords by frequency (from each interaction's topic field).",
        'Includes interactions with at least one Type of Work marked Proactive and no Types of Work marked Reactive.',
        'Topics are counted exactly as entered (spelling, capitalization, and spacing matter).',
        'Uses your selected filters.',
      ],
    },

    'top-media-issue-topics-word-cloud': {
      subTitle: 'The issue themes showing up most often',
      headerBadges: ['Issue'],
      scope: 'Included: interactions tagged as Issue or Issue Response (within your filters).',
      infoTitle: 'How this chart is counted',
      infoBody: [
        "Shows issue topic keywords by frequency (from each interaction's topic field).",
        'Includes interactions tagged as Issue or Issue Response.',
        'Topics are counted exactly as entered (spelling, capitalization, and spacing matter).',
        'Uses your selected filters.',
      ],
    },

    'top-experts-word-cloud': {
      subTitle: 'Which spokespeople appear most often',
      scope: 'Included: experts linked to media interactions (excluding blank and TBD).',
      infoTitle: 'How this chart is counted',
      infoBody: [
        "Shows experts/spokespeople by how often they're linked to media interactions.",
        'Entries with no expert name, or with "TBD," are excluded.',
        'Uses your selected filters.',
      ],
    },

    'top-engagement-topics-overall': {
      subTitle: 'The most common topics across all engagement entries',
      scope: 'Included: all engagement entries in your selected filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups engagement entries by the Topic field.',
        'Includes all engagement entries in your selected filters.',
        'Topics are counted exactly as entered (spelling, capitalization, and spacing matter).',
      ],
    },

    'top-engagement-topics-word-cloud': {
      subTitle: 'What stakeholder conversations are focusing on most',
      scope: 'Included: engagement entries in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        "Shows engagement topic keywords by frequency (from each engagement's topic field).",
        'Topics are counted exactly as entered (spelling, capitalization, and spacing matter).',
        'Uses your selected filters.',
      ],
    },

    'engagements-by-type': {
      subTitle: "What kinds of stakeholder engagement you're logging most",
      headerBadges: ['Type'],
      scope: 'Included: engagement entries in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups engagement entries by Type.',
        'If an engagement has multiple Types of Work, it is counted in each applicable Type.',
        'Uses your selected filters.',
      ],
    },

    'types-of-organizations-engaged': {
      subTitle: "Which organizations you're engaging with most",
      scope: 'Included: engagement entries in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups engagement entries by organization.',
        'Counts engagements per organization within your selected filters.',
      ],
    },

    'top-services-by-unit': {
      subTitle: 'Where service work is landing across the organization',
      scope: 'Included: services in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups services by Unit.',
        'Services without a unit appear under "No units."',
        "If you filter to specific Units, unassigned items won't be included in that filtered view.",
        'Uses your selected filters.',
      ],
    },
  },

  tables: {
    'all-media-interactions': {
      subTitle: 'A full list of interactions matching your filters',
      scope: 'Included: media interactions in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'This is the full list behind the charts for this view.',
        'Uses your selected filters (Status, Type, Outlet, Department, Campaigns, Units, Team Members).',
      ],
    },

    'all-media-services': {
      subTitle: 'A full list of services matching your filters',
      scope: 'Included: services filtered by the date logged on each entry and your selected filters.',
      infoTitle: 'How this table is built',
      infoBody: [
        'Shows services that match your filters.',
        'Date filtering is based on the date logged on each entry.',
        'If an entry is missing a logged date, it can still be included in charts (which use the best available date), but not appear in this table for the same date range.',
        'Outlet filtering does not apply to services.',
      ],
    },

    'media-interactions-in-progress': {
      subTitle: "What's currently active and needs follow-up",
      scope: 'Included: media interactions currently marked In Progress in your selected date range and filters.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'This is an action list for follow-up work.',
        'Uses your selected filters (Type, Outlet, Department, Campaigns, Units, Team Members).',
      ],
    },
  },
};

const copyFields = [
  'subTitle',
  'scope',
  'infoTitle',
  'infoBody',
  'badges',
  'headerBadges',
  'sectionLabel',
  'showSectionAccent',
];

export const getUICopyFieldsForItem = (copyConfig, queryKey) => {
  if (!queryKey || !copyConfig?.[queryKey]) {
    return {};
  }

  return copyFields.reduce((acc, field) => {
    if (copyConfig[queryKey][field] !== undefined) {
      acc[field] = copyConfig[queryKey][field];
    }
    return acc;
  }, {});
};
